export enum AlignmentNavigationTab {
  None = 0,
  Dialog,
  Instructions,
}
